import { Routes } from '@angular/router';
import { ChangesNotSavedGuard } from '../../shared/components/changes-not-saved';
import { AuthGuard } from '../auth/guards';
import { AccountComponent } from './account.component';
import { PersonalInformationComponent } from './pages';

export const accountRoutes: Routes = [
    {
        path: ':clientCode/account',
        component: AccountComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: 'personal-information',
                component: PersonalInformationComponent,
                canDeactivate: [ChangesNotSavedGuard]
            },
            { path: '', redirectTo: 'personal-information', pathMatch: 'full' }
        ]
    }
];
